import React, { useEffect, useMemo, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { columnsB0501 } from 'constants/reportColumns';
import { BProps, DataTypeB0501 } from 'store/ducks/Reportings/types';

const B0501: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed, headers } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeB0501[]>([]);
  const memoizedColumns = useMemo(() => columnsB0501, [columnsB0501]);
  const dispatch = useDispatch();
  const fetchData = async () => {
    dispatch(set_isDisplayed(false));
    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };
    try {
      const fetchedData = await reportingOp.fetchRT0501(params);

      if (fetchedData && fetchedData.entities) {
        const date = fetchedData.date;
        const allEntities = Object.values(fetchedData.entities).flat();

        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: dataItem.entity_name,
            identification_code_of_ICT_provider:
              dataItem['ICT service provider code'],
            type_of_code: dataItem['Type of ICT service provider code'],
            name_of_the_ICT_provider: dataItem['Name of ICT service provider'],
            type_of_person: dataItem['Type of person'],
            country: dataItem['Headquarters country'],
            currency_reported: dataItem['Reported currency'],
            total_annual_expense: dataItem['Total annual expense'],
            identification_code_of_ICT_providers_ultimate_parent:
              dataItem['Ultimate parent code'],
            type_of_code_to_identify_ultimate_parent:
              dataItem['Type of ultimate parent code'],
            additional_code:
              dataItem[
                'Additional identification code of ICT third-party service provi'
              ],
            type_of_additional_code:
              dataItem[
                'Type of additional identification code to identify the ICT thir'
              ],
            legal_name:
              dataItem['Legal name of the ICT third- party service provider'],
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed, entityName]);

  return (
    <>
      <Table
        columns={columnsB0501}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default B0501;
